import { useCart } from "../../context/CartContext";

const CartItem = ({ item, image }) => {
  const { removeItem } = useCart();

  return (
    <div className="cart-item">

      <div className="cart-left">

        <img
          src={
            image
              ? `${image}`
              : "https://via.placeholder.com/70"
          }
          className="cart-img"
        />

        <div className="cart-info">

          <h4 className="cart-name">{item.name}</h4>

          <div className="cart-meta">
            <span>₹{item.price}</span>
            <span className="qty">Qty: {item.quantity}</span>
          </div>

        </div>

      </div>

      <button className="remove-btn" onClick={() => removeItem(item.product_id)}>
        Remove
      </button>

    </div>
  );
};

export default CartItem;